module.exports = __webpack_public_path__ + "static/media/(H)-Artesanato-16.41cc385c.jpg";